import { render } from "./ProjectView.vue?vue&type=template&id=85a80a50&scoped=true&ts=true"
import script from "./ProjectView.vue?vue&type=script&lang=ts"
export * from "./ProjectView.vue?vue&type=script&lang=ts"

import "./ProjectView.vue?vue&type=style&index=0&id=85a80a50&lang=scss&scoped=true"

import exportComponent from "/home/steffen/IdeaProjects/Antara/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85a80a50"]])

export default __exports__